import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
// 新窗口打开页面时，保证数据不丢失
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    houseType: state.houseType, // 这个就是存入localStorage的值
    houseStyle: state.houseStyle,
    houseArea: state.houseArea,
    dsignerType: state.dsignerType,
  })
})
const store = new Vuex.Store({
  state: {
    houseType: "", //户型 
    houseStyle: "", //装修风格 
    houseArea: "", //面积 
    dsignerType:"", //设计师类型
  },
  mutations: {
    //更新户型 
    changeHouseType(state, marr) {
      state.houseType = marr;
    },
    //更新风格
    changeHouseStyle(state, marr) {
      state.houseStyle = marr;
    },
    //更新面积
    changeHouseArea(state, marr) {
      state.houseArea = marr;
    },
    //更新设计师类型
    changeDsignerType(state, marr) {
      state.dsignerType = marr;
    }
  },
  actions: {},
  plugins: [vuexLocal.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js